export default {
  id: '',
  save: false,
}
